import { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';
import { Button, Icon } from '../../../../../../components';
import FormLayout from '../../../../layout/FormLayout/FormLayout';
import Select from '../../../../../../components/Select/Select';
import { Icons } from '../../../../../../components/Icon/Icon';
import { createPortal } from 'react-dom';

const LocalTaxStatusCreateForm = ({ selectedData, countries, taxStatus, onSave, onClose }: any) => {
    const [items, setItems] = useState<any[]>(
        selectedData?.length
            ? selectedData
            : [
                  {
                      domicile: {},
                      taxStatus: {},
                  },
              ],
    );

    const handleSelectChange = (index: number, prop: string) => (value: any) => {
        let tmp = [...items];
        tmp[index] = { ...tmp[index], [prop]: value };
        setItems(tmp);
    };

    const handleAddItem = () => {
        setItems([
            ...items,
            {
                value: uuidv4(),
                domicile: {},
                taxStatus: {},
            },
        ]);
    };

    const handleRemoveItem = (index: number) => () => {
        const tmp = [...items];
        tmp.splice(index, 1);
        setItems(tmp);
    };

    return (
        <>
            {createPortal(
                <FormLayout
                    title={'Local tax status'}
                    description={'Please provide local tax status for the investment vehicle.'}
                    isAbsolute={true}
                    footerMain={
                        <Button
                            onClick={onSave('localTaxStatus', items)}
                            disabled={!!items.find((i) => !i.domicile?.domicileId)}
                        >
                            Upload
                        </Button>
                    }
                    minSize={'md'}
                    footerAdditional={
                        <Button
                            secondary={true}
                            outlined={true}
                            type={'button'}
                            before={<Icon icon={Icons.add} />}
                            onClick={handleAddItem}
                            minWidth={true}
                            disabled={!!items.find((i) => !i.domicile?.domicileId)}
                        >
                            Add Line
                        </Button>
                    }
                    onClose={onClose}
                >
                    {items.map((item: any, index: number) => (
                        <div
                            key={index}
                            style={{
                                // marginBottom: '40px',
                                gridGap: '48px',
                                display: 'grid',
                                gridTemplateColumns: 'repeat(2, calc(50% - 24px))',
                            }}
                        >
                            <Select
                                style={'small'}
                                value={item.domicile.value}
                                onChange={handleSelectChange(index, 'domicile')}
                                options={countries}
                                valueKey={'domicileId'}
                                labelKey={'domicileName'}
                                placeholder={'Choose domicile'}
                                menuPlacement={'bottom'}
                                afterLabel={
                                    <button
                                        style={{
                                            minWidth: 32,
                                        }}
                                        type={'button'}
                                        onClick={handleRemoveItem(index)}
                                    >
                                        <Icon icon={Icons.closeRounded} />
                                    </button>
                                }
                            >
                                Domicile
                            </Select>

                            <Select
                                style={'small'}
                                value={item.taxStatus.value}
                                onChange={handleSelectChange(index, 'taxStatus')}
                                options={taxStatus}
                                valueKey={'taxStatusId'}
                                labelKey={'taxStatus'}
                                placeholder={'Choose tax status'}
                                menuPlacement={'bottom'}
                            >
                                Tax Status
                            </Select>
                        </div>
                    ))}
                </FormLayout>,
                document && document.getElementById('formWrapper')!,
            )}
        </>
    );
};

export default LocalTaxStatusCreateForm;
